import { render, staticRenderFns } from "./shopDetailControl.vue?vue&type=template&id=2d38f14e&scoped=true&"
import script from "./shopDetailControl.vue?vue&type=script&lang=js&"
export * from "./shopDetailControl.vue?vue&type=script&lang=js&"
import style0 from "./shopDetailControl.vue?vue&type=style&index=0&id=2d38f14e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d38f14e",
  null
  
)

export default component.exports